export const APP_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export type AppSlugResolution = {
  slug: string | null
  isMissing: boolean
  isInvalid: boolean
}

export function resolveAppSlug(raw: string | null | undefined): AppSlugResolution {
  if (raw === null || raw === undefined) {
    return { slug: null, isMissing: true, isInvalid: false }
  }

  const trimmed = raw.trim()
  if (!trimmed) {
    return { slug: null, isMissing: true, isInvalid: false }
  }

  if (!APP_SLUG_PATTERN.test(trimmed)) {
    return { slug: null, isMissing: false, isInvalid: true }
  }

  return { slug: trimmed, isMissing: false, isInvalid: false }
}

export function getPathSegments(pathname: string): string[] {
  if (!pathname) {
    return []
  }

  return pathname
    .split('/')
    .filter(Boolean)
    .map((segment) => {
      try {
        return decodeURIComponent(segment)
      } catch {
        return segment
      }
    })
}
